<div
    id="HeaderReportComponent"
    [class.device-mobile]="isMobile()"
    [class.device-desktop]="!isMobile()"
>
    <div class="header-report-component_area">
        @if (isMobile()) {
            <div
                class="header-report-component_content header-report-component-mobile"
            >
                <div class="header-report-component_head">
                    @if (company?.props?.picture) {
                        <div
                            fxLayout="row"
                            fxLayoutAlign="none center"
                            class="gap-12"
                        >
                            <dsn-avatar
                                [src]="company?.props?.picture"
                                [size]="'medium'"
                                [initials]="company?.initialsAccountingName"
                                [fillBackground]="true"
                            ></dsn-avatar>

                            @if (company?.getDocumentFormatted()) {
                                <span
                                    class="header-report-component_head-title text-14-regular"
                                    >{{ company?.getDocumentFormatted() }}</span
                                >
                            }
                        </div>
                    } @else {
                        <div
                            fxLayout="column"
                            class="gap-12"
                            fxLayoutAlign="none none"
                        >
                            @if (!company?.getDocumentFormatted()) {
                                <div
                                    style="max-width: 90px; width: 90px"
                                    fxLayout="row"
                                    fxLayoutAlign="center center"
                                    class="text-center gap-12"
                                >
                                    <span
                                        class="text-center text-12-semi-bold color-text-white-primary"
                                        >{{ company?.getShortenedName() }}</span
                                    >
                                </div>
                            } @else {
                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="none center"
                                    class="gap-12"
                                >
                                    <span
                                        class="text-center text-16-bold color-text-white-primary"
                                        >{{ company?.getShortenedName() }}</span
                                    >
                                </div>
                            }

                            @if (company?.getDocumentFormatted()) {
                                <span
                                    class="header-report-component_head-title text-14-regular"
                                    >{{ company.getDocumentFormatted() }}</span
                                >
                            }
                        </div>
                    }

                    @if (company?.props?.accounting?.picture) {
                        <dsn-avatar
                            [src]="company?.props?.accounting?.picture"
                            [size]="'medium'"
                            [initials]="company?.initialsCompany"
                            [fillBackground]="true"
                        ></dsn-avatar>
                    } @else {
                        <div
                            style="max-width: 90px; width: 90px"
                            fxLayout="column"
                            fxLayoutAlign="center center"
                            class="text-center"
                        >
                            <span
                                class="text-center text-12-semi-bold color-text-white-primary"
                                >{{ company?.props?.accounting?.name }}</span
                            >
                        </div>
                    }
                </div>
                @defer (when reportName) {
                    <h1 class="header-report-component_head-title text-14-bold">
                        {{ reportName }}
                    </h1>
                } @placeholder {
                    <dsn-skeleton-loader
                        [type]="'rectangle'"
                        [width]="'146px'"
                        [height]="'20px'"
                    ></dsn-skeleton-loader>
                }
            </div>
        } @else {
            <div
                class="header-report-component_content header-report-component-desktop"
            >
                <div
                    class="header-report-component_head m-24"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                >
                    <div
                        class="header-report-component_avatar-info"
                        fxLayout="row"
                        fxLayoutAlign="none center"
                    >
                        @if (company?.props?.picture) {
                            <dsn-avatar
                                [fillBackground]="true"
                                [src]="company?.props?.picture"
                                [size]="'large'"
                                [initials]="company?.initialsAccountingName"
                            ></dsn-avatar>
                        }
                        <div
                            class="header-report-component_avatar-info-content"
                            fxLayout="column"
                        >
                            @defer (when company?.props.name) {
                                <div
                                    fxLayout="column"
                                    class="header-report-component_avatar-info-content-document gap-12"
                                >
                                    <h1
                                        class="header-report-component_head-title h3-18-bold"
                                    >
                                        {{ company?.props.name }}
                                    </h1>

                                    @if (company?.getDocumentFormatted()) {
                                        <span
                                            class="header-report-component_head-title text-16-regular"
                                            >{{
                                                company.getDocumentFormatted()
                                            }}</span
                                        >
                                    }
                                </div>
                            } @placeholder {
                                <dsn-skeleton-loader
                                    [type]="'rectangle'"
                                    [width]="'241px'"
                                    [height]="'20px'"
                                ></dsn-skeleton-loader>
                            }
                            <div
                                class="header-report-component_avatar-info-content_data gap-4"
                                fxLayout="column"
                            >
                                @defer (when dateLabel()) {
                                    <h2 class="h3-18-bold">
                                        {{ reportName }}
                                    </h2>
                                } @placeholder {
                                    <div fxLayout="column" class="gap-8">
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'242px'"
                                            [height]="'22px'"
                                        ></dsn-skeleton-loader>
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'141px'"
                                            [height]="'22px'"
                                        ></dsn-skeleton-loader>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    @if (company?.props?.accounting?.picture) {
                        <dsn-avatar
                            [fillBackground]="true"
                            [src]="company?.props?.accounting?.picture"
                            [size]="'large'"
                            [initials]="company?.initialsCompany"
                            [id]="'company-avatar'"
                        ></dsn-avatar>
                    } @else {
                        <div
                            style="max-width: 114px; width: 114px"
                            fxLayout="column"
                            fxLayoutAlign="center center"
                            class="text-center"
                        >
                            @if (company?.props?.accounting?.name) {
                                <span
                                    class="text-center h3-18-semi-bold color-text-white-primary"
                                    >{{
                                        company?.props?.accounting?.name
                                    }}</span
                                >
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
